export default __webpack_public_path__ + "static/media/defient_lil-b.2c614e38.svg";